<style scoped lang="scss">
.wrapper {
  margin: 0 auto 10px;
}

.breadcrumb {
  height: 45px;
  line-height: 45px;
  .el-breadcrumb {
    display: inline-block;
  }
}

.main {
  min-height: calc(100vh - 170px);
  background: #fff;
  border-radius: 6px;

  .top {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 30px;
    border-radius: 6px;
    .step {
      margin: 0 60px;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      opacity: 1;
      font-family: Source Han Sans SC;
      color: #aac9ff;
      .icon,
      .text {
        height: 30px;
        display: inline-block;
        line-height: 30px;
        vertical-align: middle;
      }

      .index {
        display: inline-block;
        border-radius: 50%;
        height: 22px;
        width: 22px;
        text-align: center;
        line-height: 22px;
        color: #fff;
        background: #bbd6ff;
        font-size: 14px;
        font-weight: bold;
        margin-right: 10px;
      }
    }
    .active {
      color: rgba(71, 142, 255, 1);
    }
    .dots {
      height: 30px;
      line-height: 30px;
      .dot {
        display: inline-block;
        width: 4px;
        height: 4px;
        background: rgba(71, 142, 255, 1);
        border-radius: 50%;
        opacity: 1;
        margin-left: 5px;
        vertical-align: middle;
      }
    }
  }
  .data-container {
    width: 500px;
    margin: 0 auto;
    .download-template {
      position: absolute;
      top: 1px;
      left: 233px;
      font-size: 12px;
      color: #666;
    }
  }
}
</style>

<style lang="scss">
.task-list {
  .export-form {
    text-align: center;
    .el-dialog__body {
      padding: 20px 20px 0;
      h3 {
        text-align: center;
        font-size: $font-size-large;
        color: #333;
        margin: 25px 0;
      }
    }
    .el-dialog__footer {
      text-align: center !important;
    }
  }
}
</style>

<template>
  <div class="wrapper task-list">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/tool/classAssign/intro'}">精准教学分班</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/tool/classAssign/list'}">精准教学分班汇总</el-breadcrumb-item>
        <el-breadcrumb-item>新增记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main">
      <div class="top">
        <div class="step active">
          <span class="icon">
            <img style="height:30px" src="~images/check_icon.png" alt />
          </span>
          <span class="text">选择导入成绩</span>
        </div>
        <div class="dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
        <div class="step">
          <span class="index">2</span>
          <span class="text">设置规则</span>
        </div>
      </div>

      <div class="data-container">
        <el-form>
          <el-form-item label="分班名称：">
            <el-input style="width:200px" v-model="uploadData.taskName" placeholder="请输入分班班级名称"></el-input>
          </el-form-item>
          <el-form-item style="positive:relative" label="考试成绩：">
            <el-upload
              class="upload-demo"
              ref="upload"
              :headers="headers"
              accept=".xls, .xlsx"
              :action="domain + '/marking-main/divide/upload_data'"
              :data="uploadData"
              :on-remove="handleRemove"
              :on-success="handleSuccess"
              :on-error="handleError"
              :file-list="fileList"
              :auto-upload="false"
            >
              <el-button slot="trigger" size="small" type="text">请导入成绩</el-button>
            </el-upload>
            <a
              class="download-template"
              download
             :href="getOssUrl('oss-cn-hangzhou.aliyuncs.com/template/%E5%88%86%E7%8F%AD%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88%20.xlsx')"
            >模板下载</a>
          </el-form-item>
          <el-form-item label="分区个数：">
            <el-input style="width:200px" v-model="uploadData.regionNum" disabled></el-input>
          </el-form-item>
          <el-form-item label="分班类型：">
            <el-radio-group v-model="uploadData.taskType">
              <el-radio :label="0">普通</el-radio>
              <el-radio :label="1">带C+</el-radio>
              <el-radio :label="2">初三带C+</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div style="margin-top:100px;text-align:center">
          <el-button
            style="padding-left:20px;padding-right:20px;"
            size="small"
            type="primary"
            :loading="loading"
            @click="submitUpload"
          >下一步</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/common/SearchBar";

import { mapGetters } from "vuex";
import {} from "@/api/tool";
import { domain } from "@/config";
export default {
  data() {
    return {
      loading: false,
      headers: {
        token: YJ_SCHOOL_STORAGE.getItem('token')
      },
      uploadData: {
        taskType: 0,
        schoolId: "",
        taskName: "",
        regionNum: 2
      },
      domain: domain,
      fileList: []
    };
  },
  components: {
    SearchBar
  },
  mounted() {
    this.uploadData.schoolId = this.userInfo.schoolId;
  },

  methods: {
    handleSuccess(res, file, filelist) {
      this.loading = false;
      if (res.code == 200) {
        if (res.result.isUploadSuccess == 1) {
          this.$router.replace(
            "/tool/classAssign/create_step2?taskId=" +
              res.result.taskId +
              "&taskName=" +
              this.uploadData.taskName
          );
        } else {
          this.$message.warning("上传出错");
          this.fileList = [];
          let url = res.result.errorExcelUrl;
          window.open(url);
        }
      } else {
        this.fileList = [];
        return this.$message.warning(res.message);
      }
    },
    handleError(res, file, filelist) {
      this.loading = false;
      this.$message.error(res.message);
    },
    handleRemove() {
      this.fileList = [];
    },
    submitUpload() {
      if (
        this.uploadData.taskName == "" ||
        this.uploadData.taskName.trim() == ""
      ) {
        return this.$message.warning("请输入任务名称");
      }
      this.loading = true;
      this.$refs.upload.submit();
    }
  },

  computed: {
    ...mapGetters({
      userInfo: "getUserInfo"
    })
  }
};
</script>
